module.exports = __webpack_public_path__ + "static/media/_comma.18a2b100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_comma.jpg
// module id = 50
// module chunks = 0